import { createPost, fetchPost } from "app/actions/postingForm";
import { useActions } from "app/utils/hooks";
import usePlanFeature from "app/utils/services/plan_feature/user";
import { shallowEqual, useSelector } from "react-redux";
import { RootState } from "typedefs";
import { useCallback } from "react";

interface UsePostingFormBaseOptions {
  entityPlanPermissions?: string[];
  entityPermissions?: string[];
  checkEntityPermissions?: boolean;
}

export const usePostingFormBase = (options: UsePostingFormBaseOptions = {}) => {
  const {
    entityPlanPermissions,
    entityPermissions,
    checkEntityPermissions = false,
  } = options;

  const postActions = useActions({ createPost, fetchPost });

  const { self: user } = useSelector(
    (state: RootState) => state.user,
    shallowEqual,
  );

  const { canSchedulePosts, canAddMedia, canPostMedia } = usePlanFeature(user);

  const canUploadMedia = useCallback((): boolean => {
    if (!user) {
      return false;
    }

    const hasBasePermission = canAddMedia && canPostMedia;

    if (!entityPlanPermissions) {
      return hasBasePermission;
    }

    const hasEntityPlanPermission =
      entityPlanPermissions.includes("post_media");

    if (checkEntityPermissions) {
      if (!entityPermissions) {
        return false;
      }
      return (
        hasBasePermission &&
        hasEntityPlanPermission &&
        entityPermissions.includes("post_media")
      );
    }

    return hasBasePermission && hasEntityPlanPermission;
  }, [
    user,
    canAddMedia,
    canPostMedia,
    entityPlanPermissions,
    entityPermissions,
    checkEntityPermissions,
  ]);

  return {
    user,
    canSchedulePosts,
    canAddMedia,
    canPostMedia,
    canUploadMedia,
    postActions,
  };
};
